module.exports = __webpack_public_path__ + "static/media/Nico Arcino.785511c8.png";